import { Button } from '@mui/material';
import { L } from 'harmony-language';
import React, { FormEvent } from 'react';
import { LocationColors } from '../../../styles/agistics-colors';
import type { LocationType, LocationTypeColor } from '../../../types';
import { AgisticsSelect } from '../../shared/agistics-select';
import { ColorSelector } from '../../shared/inputs/color-selector';

interface EditCreateLocationTypeColorProps {
    existingLocationTypeColor: LocationTypeColor;
    locationTypes: LocationType[];
    addLocationTypeColor: (data: LocationTypeColor) => Promise<void>;
    editLocationTypeColor: (data: LocationTypeColor) => Promise<void>;
    closeModal: () => void;
}

export const EditCreateLocationTypeColor = (props: EditCreateLocationTypeColorProps) => {
    const { existingLocationTypeColor, locationTypes, addLocationTypeColor, editLocationTypeColor, closeModal } = props;

    const [locationTypeColor, setLocationTypeColor] = React.useState<LocationTypeColor>(existingLocationTypeColor || {
        organizationLocationTypeId: -1,
        hexColor: '',
    });

    async function submitForm(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();

        if (locationTypeColor.id) {
            await editLocationTypeColor(locationTypeColor);
        } else {
            await addLocationTypeColor(locationTypeColor);
        }

        closeModal();
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            <form name='edit-create-location-type-color-form' onSubmit={submitForm}>
                <div style ={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'flex-end' }}>
                    <div style={{ width: '100%'}}>
                        <AgisticsSelect
                            label={L.locationType()}
                            item={locationTypeColor.organizationLocationTypeId}
                            items={locationTypes.map(type => ({ id: type.id, value: type.name }))}
                            onChange={(value) => setLocationTypeColor(locationTypeColor => ({ ...locationTypeColor, organizationLocationTypeId: value }))}
                        />
                    </div>
                    <ColorSelector
                        value={locationTypeColor.hexColor}
                        onChange={(color) => setLocationTypeColor(locationTypeColor => ({ ...locationTypeColor, hexColor: color }))}
                        colors={Object.values(LocationColors)}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1rem' }}>
                    <Button
                        type='submit'
                        title={L.save()}
                        variant='contained'
                        color='primary'
                        disabled={locationTypeColor.organizationLocationTypeId === -1}
                    >
                        {existingLocationTypeColor ? L.updateLocationTypeColor() : L.createLocationTypeColor()}
                    </Button>
                </div>
            </form>
        </div>
    );
};